import React from 'react';


export default class Support extends React.PureComponent {

    sendLog = async() => {
        await window.sdk.session().sendLog();
        window.sdk.event().emit('toast',{message:'Les logs ont bien été envoyés'});
    }

    render(){
        return(
        <div className="settings-support">
            <div className="settings__block">
            <h3 className={'settings__subtitle'}>Support technique</h3>
                <p>Afin de nous aider à améliorer cette application et corriger des bugs, vous pouvez nous envoyer vos logs et vos erreurs.</p>
                <div className='settings-support__submitwrap'>
                    <button className='button button--primary settings-support__submit' onClick={this.sendLog}>Envoyer le log</button>
                </div>
                <div className='settings-support__info'>
                    Notre support technique est disponible au +33.0184671300 
                    ou par email sur : support@hocoia.com
                </div>
            </div>
        </div>)
    }
}